<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <div class="right-menu" style="display: flex;align-items: center;margin: 0 20px;">
        <!-- 消息通知 -->
        <notification-drawer></notification-drawer>

        <!-- 主题切换按钮 -->
        <el-tooltip :content="theme === 'dark' ? '切换到浅色主题' : '切换到深色主题'" placement="bottom">
          <el-button class="theme-toggle-btn" @click="toggleTheme">
            <span v-if="theme === 'dark'">浅色模式</span>
            <span v-else>深色模式</span>
          </el-button>
        </el-tooltip>
        <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link" style="cursor: pointer">
         欢迎，{{ userInfo.userName }} <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="owner">个人信息</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
    <el-dialog
      title="个人信息"
      :visible.sync="dlgShow"
      width="30%"
      :before-close="handleClose">
      <div class="cycle-tip-container">
        <div class="cycle"></div>
        <div class="tip-text">可修改个人信息及新密码</div>
      </div>
      <el-form :model="form" label-position="top" :rules="rule" ref="form">
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="form.nickName" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="form.pwd" placeholder="输入新密码后保存既生效" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="save" size="small">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Hamburger from '@/components/Hamburger';
import NotificationDrawer from '@/components/NotificationDrawer';
import {getToken} from '@/utils/auth'
export default {
  components: {
    Hamburger,
    NotificationDrawer
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar']),
    ...mapState({
      theme: state => state.settings.theme
    })
  },
  data() {
    return {
      color1: '#409EFF',
      userInfo: {
        userName: ''
      },
      dlgShow: false,
      form: {
        id: '',
        nickName: '',
        phone: '',
        pwd: '',
      },
      rule: {
        nickName: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        phone: [{required: true, message: '请输入手机号', trigger: 'blur'}],
      }
    };
  },
  mounted() {
    let that = this
    setTimeout(function () {
      that.userInfo.userName = localStorage.getItem("currentUserName")
    }, 500)
    // 开启未读消息轮询
    if (getToken()) {
      this.$store.dispatch('notification/startPolling')
    }
  },
  methods: {
    handleClose() {
      this.form.id = ''
      this.form.nickName = ''
      this.form.phone = ''
      this.form.pwd = ''
      this.dlgShow = false
    },
    handleCommand(type) {
      this[type]()
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    },
    toggleTheme() {
      this.$store.dispatch('settings/toggleTheme')
    },
    owner() {
      if(getToken()){
        this.api({
          url: this.baseUrl + '/ceRole/getInfo',
          method: 'post'
        }).then(data => {
          if (data.status === 0) {
            this.form.id = data.data.userId
            this.form.nickName = data.data.nickname
            this.form.phone = data.data.phone
            this.form.pwd = ''
            this.dlgShow = true
          }
        })
      }else {
        this.$router.push({path: '/login', query: {}});
      }

    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          this.$message.error('请完善表单！');
        }
      });
    },
    submit(){
      this.api({
        url: this.baseUrl + '/ceUser/updateUser',
        method: 'post',
        data: this.form
      }).then(data => {
        if (data.status === 0) {
          this.$message.success(data.message);
          this.handleClose();
          location.reload()
        } else {
          this.$message.error(data.message);

        }
      });
    },
    logout() {
      this.$store.dispatch('notification/stopPolling')
      this.$store.dispatch('FedLogOut').then(() => {
        this.$websocket.close();
        localStorage.removeItem("tokenVue");
        localStorage.removeItem("currentDevice");
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
      //
      // this.$router.push({path: '/login', query: {}});
      // window.location.reload();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: var(--bg-primary);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    & :hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    & :focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 10px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;
      margin-right: 15px;

      & .hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        & :hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

// 主题切换按钮样式
.theme-toggle-btn {
  margin-right: 15px;
  background-color: white;
  border: 1px solid var(--border-default);
  color: var(--text-secondary);
  border-radius: 8px;
  padding: 8px 16px;

  &:hover {
    background-color: var(--bg-hover);
    border-color: var(--primary);
    color: var(--primary);
  }
}
</style>

<style lang="scss">
// 深色主题下 navbar 的额外样式
.dark-theme {
  .navbar {
    background: var(--bg-primary);
    border-bottom: 1px solid var(--border-default);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue